import React from 'react';
import './sunken_ship_sparkles.scss';

const ShipSparkles = () => {
  return (
    <div className="App_sunken_ship_sparkles">
      <div className="App_sparkle s1"> </div>
      <div className="App_sparkle s2"> </div>
      <div className="App_sparkle s3"> </div>
      <div className="App_sparkle s4"> </div>
      <div className="App_sparkle s5"> </div>
      <div className="App_sparkle s6"> </div>
      <div className="App_sparkle s7"> </div>
      <div className="App_sparkle s8"> </div>
      <div className="App_sparkle s9"> </div>
      <div className="App_sparkle s10"> </div>
    </div>
  );
};

export default ShipSparkles;
